const secureHeader: any = {};

export const secureFetch = async (resource: string, options?: RequestInit | undefined): Promise<Response|Error> => {

    const fetchOpts: RequestInit = {
        headers: {
          "Content-Type": "application/json",
        },
    };
      
    options = (options === undefined || options === null ? {} : options);
    const opts = { ...fetchOpts, ...options };

    let req = new Request(resource, opts);

    if (!secureHeader.token) {
        const params = new URLSearchParams(window.location.search);
        const apiKey = params.get("apiKey");
       
        req.headers.set('apiKey', apiKey === null ? '' : apiKey);
    } else {
        req.headers.set('token', secureHeader.token);
    }
    
    if (!secureHeader.CE) {
        const params = new URLSearchParams(window.location.search);
        secureHeader.CE = params.get('CE');
    }    
    const allowedCEs = new Set(["P", "T", "B"]);
    if (allowedCEs.has(secureHeader.CE)) {
        req.headers.set('CE', secureHeader.CE);
    } else {
        req.headers.set('CE', 'B');
    }  

    let resp : Response|Error|null = null;
    try{
        resp = await window.fetch(req);
    }catch (e : any){
        resp = e as Error;
    }

    if (resp !== null && resp instanceof Response) {
        if (resp.headers.get('token') !== undefined && resp.headers.get('token') !== null) {
            secureHeader['token'] = resp.headers.get('token');
        }
    }

    return resp!;
}